import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';

const NAV = [
  { to: '/', label: 'Home' },
  { to: '/services', label: 'Services' },
  { to: '/about', label: 'About' },
  { to: '/projects', label: 'Projects' },
  { to: '/premium', label: 'Luxury Homes' },
  { to: '/contact', label: 'Contact' },
];

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  const isActive = (path) => {
    if (path === '/') return location.pathname === '/' ? 'active' : '';
    return location.pathname === path || location.pathname.startsWith(`${path}/`) ? 'active' : '';
  };

  return (
    <header className={`site-header${scrolled ? ' scrolled' : ''}`}>
      <div className="nav-container">
        <Link to="/" className="logo" aria-label="ProClimb Solutions - home">
          <img
            src="/img/logo-128.webp"
            srcSet="/img/logo-64.webp 1x, /img/logo-128.webp 2x"
            alt="ProClimb Solutions"
            width="150"
            height="56"
            fetchPriority="high"
          />
        </Link>

        <nav className={`nav-menu ${mobileMenuOpen ? 'mobile-open' : ''}`} aria-label="Main navigation">
          {NAV.map((item) => (
            <Link key={item.to} to={item.to} className={isActive(item.to)} aria-current={isActive(item.to) ? 'page' : undefined}>
              {item.label}
            </Link>
          ))}
        </nav>

        <div className="header-actions">
          <a href="tel:0426920301" className="header-phone" aria-label="Call 0426 920 301">
            <Phone size={18} aria-hidden="true" />
            0426 920 301
          </a>
          <Link to="/contact#quote-form" className="cta-btn">
            Get Quote
          </Link>
          <a href="tel:0426920301" className="cta-btn emergency-btn">
            <Phone size={16} aria-hidden="true" />
            Emergency
          </a>
          <button
            type="button"
            className="mobile-toggle"
            onClick={() => setMobileMenuOpen((open) => !open)}
            aria-label={mobileMenuOpen ? 'Close menu' : 'Open menu'}
            aria-expanded={mobileMenuOpen}
          >
            {mobileMenuOpen ? <X /> : <Menu />}
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
